import React from "react";
import * as breakpoints from "../util/breakpoints";
import Label from "../atoms/Label";
import Video from "../atoms/Video";
import Icon from "../atoms/Icon"
import Link from "../atoms/Link";
import Image from "../atoms/Image";
import Youtube from "../molecules/Youtube";
import showModal from "./Modal";
import useMediaQuery from '../util/useMediaQuery'
import useSiteData from "../../useSiteData";

export default ({ video, image, label, quote, author, youtube, youTubeText = 'Open Youtube video', link }) => {
    const isMobile = useMediaQuery({ maxWidth: breakpoints.MEDIUM - 1 });
    const isTablet = useMediaQuery({ maxWidth: breakpoints.XLARGE - 1 });
    const { translations } = useSiteData().pageSettings
    const openModal = () => {
        const element = (
            <Youtube video={ youtube }/>
        );

        showModal({ children: element, video: true, translations });
    };

    return (
        <div
            className={ "o-testimonial u-object-fit" +
            (isMobile ? " u-object-fit--2-3" : " u-object-fit--16-9") +
            (quote || author ? " o-testimonial--shadow" : "") }
        >
            <div
                className={ "o-testimonial__content" +
                (isTablet ? " o-testimonial__content--inner" : " u-container") }
            >
                <div className="o-testimonial__wrapper">
                    <Label text={ label } classes={ "o-testimonial__content-label" }/>
                </div>
                <div className="o-testimonial__wrapper">
                    <p className="o-testimonial__content-quote u-font-variation">{ quote }</p>
                    <p className="o-testimonial__content-author u-small-text">{ author }</p>
                    { (youtube ?
                        <button className="o-testimonial__btn a-btn a-btn--transparent" onClick={ openModal }>
                            <Icon iconName="icon-youtube"
                                  className="o-testimonial__btn-icon a-icon a-icon--inline a-icon--s"/>
                            { youTubeText }
                        </button> : '') }
                    { link && <Link className="o-testimonial__link" link={ link }/> }
                </div>
            </div>
            { (image && !video) &&
            <Image className="o-testimonial__media" image={ image }/>
            }
            { video &&
            <Video
                src={ video.file.url }
                className="o-testimonial__media"
                autoPlay
                playsInline
                loop
                muted
                poster={ image ? image.file.url : null }
            />
            }
        </div>
    )
};
